<template>
  <guest-layout background-class="bg-white" :color-scheme="'light'" :poper-absolute="true">

    <main class="mt-8 sm:mt-0">

      <div class="relative isolate overflow-hidden bg-gradient-to-b from-primary-100/20">
        <div class="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40">
          <div v-motion-slide-left class="px-6 lg:px-0 lg:pt-4">
            <div class="mx-auto max-w-2xl">
              <div class="max-w-lg">
                <h3 class="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{{ __('Streamline information flow with our time-saving newsletter system') }}</h3>
                <p class="mt-6 text-lg leading-8 text-gray-600">{{ __('Simplify your communication process and save valuable time with our efficient newsletter system. Designed to streamline incident updates and announcements, our system ensures that your subscribers are always up to date, empowering them with the latest information at their fingertips.') }}</p>
<!--                <div class="mt-10 flex items-center gap-x-6">-->
<!--                  <a href="#" class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Documentation</a>-->
<!--                  <a href="#" class="text-sm font-semibold leading-6 text-gray-900">View on GitHub <span aria-hidden="true">→</span></a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="mt-20 md:mx-auto md:max-w-2xl lg:mx-0 lg:w-screen hidden md:block">
            <div class="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-primary-600/10 ring-1 ring-primary-50 md:-mr-20 lg:-mr-36" aria-hidden="true" />
            <div class="shadow-lg md:rounded-3xl">
              <div class="bg-primary-500 [clip-path:inset(0)] md:[clip-path:inset(0_round_theme(borderRadius.3xl))]">
                <div class="absolute -inset-y-px left-1/2 -z-10 ml-10 w-[200%] skew-x-[-30deg] bg-primary-100 opacity-20 ring-1 ring-inset ring-white md:ml-20 lg:ml-36" aria-hidden="true" />
                <div class="relative px-6 pt-8 sm:pt-16 md:pl-16 md:pr-0">
                  <div
                      class="mb-6 bg-gray-50 rounded-lg rounded-bl-none rounded-tr-none overflow-hidden shadow-xl transform transition-all sm:w-full sm:mx-auto sm:max-w-2xl"
                      style="">
                    <div class="px-6 py-4 text-gray-900">
                      <h1 class="text-lg font-semibold">
                        {{ __('Subscribe to statuspage updates') }}
                      </h1>
                      <div class="mt-4"><label class="block font-medium text-sm text-gray-900"
                                               for="email"><span>E-Mail</span></label> <input
                          class="p-2 disabled:opacity-50 text-gray-900 focus:bg-opacity-75 focus:outline-none rounded-md shadow-sm bg-gray-200 autofill:bg-gray-200 rounded-md border-none w-full h-10"
                          id="email" placeholder="notify@email.com">
                      </div>
                    </div>
                    <div class="px-6 py-4 bg-gray-200 text-right">
                      <button type="submit"
                              class="inline-flex items-center px-4 py-2 hover:opacity-75 rounded-md font-semibold text-xs uppercase focus:outline-none tracking-widest shadow-sm duration-150 ml-2 bg-gray-700 border-gray-700 text-gray-200">
                        {{ __('Subscribe') }}
                      </button>
                    </div>
                  </div>
                  <div class="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 md:rounded-3xl" aria-hidden="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
      </div>

      <div class="bg-white py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-2xl lg:text-center">
            <h2 class="text-base font-semibold leading-7 text-primary-600">{{ __('Solution-oriented workflow') }}</h2>
            <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ __('Keep your customers up to date - Reduce support time in the event of an outage.') }}</p>
<!--            <p class="mt-6 text-lg leading-8 text-gray-600">Quis tellus eget adipiscing convallis sit sit eget aliquet quis. Suspendisse eget egestas a elementum pulvinar et feugiat blandit at. In mi viverra elit nunc.</p>-->
          </div>
          <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
            <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
              <div v-for="feature in features" :key="feature.name" class="relative pl-16">
                <dt class="text-base font-semibold leading-7 text-gray-900">
                  <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                    <component :is="feature.icon" class="h-6 w-6" aria-hidden="true" />
                  </div>
                  {{ __(feature.name) }}
                </dt>
                <dd class="mt-2 text-base leading-7 text-gray-600">{{ __(feature.description) }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <hr class="divider"/>

      <cheap-package-preview-box :bg-from="'bg-white'" :bg-to="'bg-white'"/>

      <feature-preview-box/>

      <hr class="divider"/>

      <c-t-a-start-today/>

    </main>

  </guest-layout>
</template>

<script setup>
import { ChevronRightIcon } from '@heroicons/vue/solid'
import GuestLayout from "@/Layouts/GuestLayout";

import { FingerPrintIcon, LockClosedIcon } from '@heroicons/vue/outline'
import {defineComponent, h} from "vue";
import PackagePricingBoxes from "@/Pages/Sites/FeatureSections/PackagePricingBoxes";
import FeaturePreviewBox from "@/Pages/Sites/FeatureSections/FeaturePreviewBox";
import CheapPackagePreviewBox from "@/Pages/Sites/FeatureSections/CheapPackagePreviewBox";
import CTAStartToday from "@/Pages/Sites/FeatureSections/CTAStartToday";

const features = [
  {
    name: 'Efficient Mail Delivery',
    description: 'Ensure smooth mail delivery with our efficient queuing system that sends emails in the background.',
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M10.4995 13.5001L20.9995 3.00005M10.6271 13.8281L13.2552 20.5861C13.4867 21.1815 13.6025 21.4791 13.7693 21.566C13.9139 21.6414 14.0862 21.6415 14.2308 21.5663C14.3977 21.4796 14.5139 21.1821 14.7461 20.587L21.3364 3.69925C21.5461 3.16207 21.6509 2.89348 21.5935 2.72185C21.5437 2.5728 21.4268 2.45583 21.2777 2.40604C21.1061 2.34871 20.8375 2.45352 20.3003 2.66315L3.41258 9.25349C2.8175 9.48572 2.51997 9.60183 2.43326 9.76873C2.35809 9.91342 2.35819 10.0857 2.43353 10.2303C2.52043 10.3971 2.81811 10.5128 3.41345 10.7444L10.1715 13.3725C10.2923 13.4195 10.3527 13.443 10.4036 13.4793C10.4487 13.5114 10.4881 13.5509 10.5203 13.596C10.5566 13.6468 10.5801 13.7073 10.6271 13.8281Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Simplified Email Creation',
    description: 'Create compelling newsletters effortlessly using our user-friendly HTML editor, empowering you to design visually appealing emails with ease.',
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Resource-Friendly Solution',
    description: 'Our newsletter system optimizes resource usage, ensuring minimal impact on your server while maintaining excellent performance.',
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M9 2V4M15 2V4M9 20V22M15 20V22M20 9H22M20 14H22M2 9H4M2 14H4M8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V8.8C20 7.11984 20 6.27976 19.673 5.63803C19.3854 5.07354 18.9265 4.6146 18.362 4.32698C17.7202 4 16.8802 4 15.2 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20ZM10.6 15H13.4C13.9601 15 14.2401 15 14.454 14.891C14.6422 14.7951 14.7951 14.6422 14.891 14.454C15 14.2401 15 13.9601 15 13.4V10.6C15 10.0399 15 9.75992 14.891 9.54601C14.7951 9.35785 14.6422 9.20487 14.454 9.10899C14.2401 9 13.9601 9 13.4 9H10.6C10.0399 9 9.75992 9 9.54601 9.10899C9.35785 9.20487 9.20487 9.35785 9.10899 9.54601C9 9.75992 9 10.0399 9 10.6V13.4C9 13.9601 9 14.2401 9.10899 14.454C9.20487 14.6422 9.35785 14.7951 9.54601 14.891C9.75992 15 10.0399 15 10.6 15Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Subscriber Management',
    description: 'Effortlessly manage your newsletter subscribers, including adding, removing, and resending verification emails.',
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
]
</script>